module.exports = __webpack_public_path__ + "img/speech_11.f7b0118f.jpeg";